(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-add-to-cart-button"] && !Shopify.designMode) return;
  try {
    (function () {

  function formatMoney(cents) {
    var nativeEl = document.querySelector('[data-ref="price"]');
    var prefix = '', suffix = '€', decimal = ',';

    if (nativeEl) {
      var text = nativeEl.textContent.trim();
      var match = text.match(/^([^\d]*)([\d.,\s]+)([^\d]*)$/);
      if (match) {
        prefix = match[1];
        suffix = match[3];
        var lastComma = match[2].lastIndexOf(',');
        var lastDot   = match[2].lastIndexOf('.');
        decimal = (lastDot > lastComma) ? '.' : ',';
      }
    }

    var amount = (cents / 100).toFixed(2).replace('.', decimal);
    return prefix + amount + suffix;
  }

  function updateButton(price, compareAtPrice) {
    var container = document.querySelector('[data-ref="add-to-cart-button-container"]');
    var priceEl   = container ? container.querySelector('[data-ref="price"]') : null;
    var wrapper   = document.querySelector('[data-ref="button-price-wrapper"]');
    if (!priceEl || !wrapper) return;

    if (price) priceEl.textContent = price;

    if (compareAtPrice) {
      if (container) container.querySelectorAll('[data-ref="compare-at-price"]').forEach(function(el) {
        el.style.display = 'none';
      });
      wrapper.textContent   = compareAtPrice;
      wrapper.style.display = 'inline';
    } else {
      if (container) container.querySelectorAll('[data-ref="compare-at-price"]').forEach(function(el) {
        el.style.display = '';
      });
      wrapper.textContent   = '';
      wrapper.style.display = 'none';
    }
  }

  /* ── KACHING ── */
  function hasNativeDiscount() {
    var el = document.querySelector('[data-ref="add-to-cart-button-container"]');
    return el && el.hasAttribute('data-compare-at-price');
  }

  function syncKaching() {
    if (hasNativeDiscount()) return;
    var bar     = document.querySelector('.kaching-bundles__bar--selected');
    var fullEl  = bar && bar.querySelector('.kaching-bundles__bar-full-price .money');
    var priceEl = bar && bar.querySelector('.kaching-bundles__bar-price .money');
    updateButton(
      priceEl ? priceEl.textContent.trim() : null,
      fullEl  ? fullEl.textContent.trim()  : null
    );
  }

  function initKaching(container) {
    new MutationObserver(syncKaching).observe(container, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    syncKaching();
    setTimeout(syncKaching, 500);
    setTimeout(syncKaching, 1200);
    setTimeout(syncKaching, 2500);
  }

  /* ── MOON ── */
  function syncMoon(instance, offerId) {
    var prices = instance.prices.get();
    var p = prices[offerId] || prices[Object.keys(prices)[0]];
    if (!p) return;
    var discounted = p.totalDiscountedPrice;
    var original   = p.totalOriginalPrice;
    updateButton(
      formatMoney(discounted),
      original > discounted ? formatMoney(original) : null
    );
  }

  function initMoon() {
    var uuid = Object.keys(window.MoonBundle).find(function (k) {
      var inst = window.MoonBundle[k];
      return inst && typeof inst === 'object' && inst.currentOffer;
    });
    if (!uuid) return;
    var instance = window.MoonBundle[uuid];

    var initial = instance.currentOffer.get();
    if (initial) syncMoon(instance, initial.id);

    instance.currentOffer.subscribe(function (offer) {
      if (!offer) return;
      syncMoon(instance, offer.id);
    });
  }

  /* ── INIT ── */
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    var kaching = document.querySelector('.kaching-bundles');
    if (kaching) { clearInterval(poll); initKaching(kaching); return; }
    if (window.MoonBundle && Object.keys(window.MoonBundle).length) {
      clearInterval(poll); initMoon(); return;
    }
    if (tries > 40) clearInterval(poll);
  }, 250);

})();
  } catch(e) { console.error(e); }
})();

})();
